import React from 'react';

const ErrorView = () => {
  return <div>ErrorView</div>;
};

export default ErrorView;
